import {  } from '@/api/api';

export default {
  namespaced: true,
  state: {
    SEO:{
      title: "Sports News, Latest Sports News & Today's Headlines | LuckScore",
      keywords: 'football news, soccer gossip news, sports news, transfer messages, pre-match analysis',
      description: 'LuckScore keeps everything of football news up-to-date. We provide lots of news about teams and players all over the world. '
    },
  },
  mutations: {
    
  },
  actions: {
    
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/news.js